import {FC} from 'react';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import EditIcon from '@mui/icons-material/Edit';

import {IDevice} from '../../../../shared/types/device.types';
import {statusCodeTranslation} from '../../../../shared/status.data';
import {Stack, Tooltip} from '@mui/material';

interface IDeviceRow {
  row: IDevice;
  toEditDevice: (device: IDevice) => () => void;
}

export const DeviceRow: FC<IDeviceRow> = ({row, toEditDevice}) => {
  return (
    <TableRow
      onDoubleClick={row.deviceStatus.moderationNeeds ? toEditDevice(row) : undefined}
      hover
      sx={{cursor: row.deviceStatus.moderationNeeds ? 'pointer' : undefined}}
    >
      <TableCell scope="row" align="left">
        {row.id}
      </TableCell>
      <TableCell padding="none">
        {row.deviceStatus.moderationNeeds ? (
          <Stack direction="column" justifyContent="center">
            <Tooltip
              PopperProps={{disablePortal: true}}
              title={`Установлено неизвестное устройство (!)\nНеобходима верификация`}
            >
              <EditIcon color="error" />
            </Tooltip>
          </Stack>
        ) : null}
      </TableCell>
      <TableCell align="left">{row.model?.model || '-'}</TableCell>
      <TableCell align="left">{row?.operator || '-'}</TableCell>
      <TableCell align="left">{row?.createdYear || '-'}</TableCell>
      <TableCell align="left">{row?.serial || '-'}</TableCell>
      <TableCell align="left">{row?.ip || '-'}</TableCell>
      <TableCell align="left">{row?.t1 ?? '-'}</TableCell>
      <TableCell align="left">{row?.t2 ?? '-'}</TableCell>
      <TableCell align="left">{row?.t3 ?? '-'}</TableCell>
      <TableCell align="left">{statusCodeTranslation['device'][row?.deviceStatus.status] || '-'}</TableCell>
    </TableRow>
  );
};
